// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"fe237aed","214":"9e107cf4","266":"52560c46","324":"ad73bcd7","462":"e3d5cf86","632":"de3a88d4","711":"ac75a3af","776":"2b5a6839","949":"39c10ed5"}[chunkId] + ".chunk.js";
};